import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function FinalCTA({
  title = "Hai un progetto in mente?",
  subtitle = "Siamo pronti a realizzarlo insieme a te.",
  primary = { label: "Richiedi un preventivo", to: "/contatti" },
  secondary = { label: "Contattaci", to: "/contatti" },
  testId = "final-cta",
}) {
  return (
    <section className="bg-drosun-navy text-white py-20" data-testid={testId}>
      <div className="max-w-[1320px] mx-auto px-5 lg:px-10 flex flex-col md:flex-row md:items-center md:justify-between gap-10">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 mb-4">
            <span className="inline-block w-10 h-[3px] bg-drosun-red" />
            <span className="text-xs font-semibold tracking-[0.2em] uppercase text-white/70">Iniziamo</span>
          </div>
          <h2 className="font-display uppercase text-4xl sm:text-5xl leading-tight">{title}</h2>
          <p className="mt-4 text-lg text-white/80">{subtitle}</p>
        </div>
        <div className="flex flex-col sm:flex-row gap-4">
          {primary && (
            <Link
              to={primary.to}
              className="inline-flex items-center justify-center gap-2 px-7 py-4 bg-drosun-red hover:bg-drosun-redHover text-white font-bold uppercase tracking-[0.12em] text-sm rounded-md transition-colors"
              data-testid={`${testId}-primary`}
            >
              {primary.label} <ArrowRight size={18} />
            </Link>
          )}
          {secondary && (
            <Link
              to={secondary.to}
              className="inline-flex items-center justify-center gap-2 px-7 py-4 bg-transparent border border-white/40 hover:bg-white/10 text-white font-bold uppercase tracking-[0.12em] text-sm rounded-md transition-colors"
              data-testid={`${testId}-secondary`}
            >
              {secondary.label} <ArrowRight size={18} />
            </Link>
          )}
        </div>
      </div>
    </section>
  );
}
